/**
 * src/pages/WhereDidWeComeFrom/WhereDidWeComeFrom.tsx
 * Entry page for "Where Did We Come From?" (Journey Question 01, "origin").
 * Educational, cinematic, dark cosmic inquiry into cosmic nucleosynthesis,
 * abiogenesis, and the hominin evolutionary bush.
 */

import React from "react";
import "./WhereDidWeComeFrom.module.css";
import "@/components/cosmic/cosmic.css";
import { OriginPageShell } from "@/components/originBeyond/OriginPageShell";
import { PageHero } from "@/components/originBeyond/PageHero";
import { EvidenceKey } from "@/components/originBeyond/EvidenceKey";
import { RelatedExperiences } from "@/components/originBeyond/RelatedExperiences";
import { JourneyBar } from "@/components/originBeyond/JourneyBar";
import { SourceList } from "@/components/originBeyond/SourceList";
import { CosmicExpansionCanvas } from "./sections/CosmicExpansionCanvas";
import { CosmicTimelineSection } from "./sections/CosmicTimelineSection";
import { StardustExplorer } from "./sections/StardustExplorer";
import { OriginOfLifeSection } from "./sections/OriginOfLifeSection";
import { BecomingHumanSection } from "./sections/BecomingHumanSection";
import { AncientMatterClosing } from "./sections/AncientMatterClosing";
import { ORIGIN_SOURCES } from "./whereDidWeComeFromData";
export default function WhereDidWeComeFromPage() {
  return <OriginPageShell accent="cyan">
      <div className="w-full max-w-full min-w-0 flex flex-col gap-12 sm:gap-16 lg:gap-20">
        {/* 1. Page Hero with Question 1 & Cosmic Expansion Canvas */}
        <PageHero questionNumber={1} eyebrow="Cosmology, Abiogenesis &amp; Deep Time" title="Where Did We Come From?" subtitle="From the expansion of spacetime 13.8 billion years ago to the synthesis of elements inside exploding stars, prebiotic molecular assembly, and the branching bush of human evolution.">
          <CosmicExpansionCanvas />
        </PageHero>

        {/* Evidence & Epistemology Guide (near top, right after hero) */}
        <section className="w-full max-w-[76rem] mx-auto px-4 sm:px-6 lg:px-8 min-w-0">
          <EvidenceKey />
        </section>

        {/* 2. 13.8 Billion Years: ScrubTimeline */}
        <CosmicTimelineSection />

        {/* 3. Stardust: Element Origin Interactive Grid */}
        <StardustExplorer />

        {/* 4. How Life May Have Begun: Origin-of-Life Hypotheses */}
        <OriginOfLifeSection />

        {/* 5. Becoming Human: Paleoanthropology & Ancient DNA */}
        <BecomingHumanSection />

        {/* 6. Reflective Closing: Ancient Matter */}
        <AncientMatterClosing />

        {/* 7. Interconnected Quantum Liaison Portals */}
        <div className="w-full max-w-[76rem] mx-auto px-4 sm:px-6 lg:px-8 min-w-0">
          <RelatedExperiences keys={["atlas", "kardashev", "discoveries", "creator"]} title="Explore Connected Cosmic Simulations" />
        </div>

        {/* Persistent Expedition Navigation */}
        <div className="w-full max-w-[76rem] mx-auto px-4 sm:px-6 lg:px-8 min-w-0">
          <JourneyBar current="origin" />
        </div>

        {/* Scholarly Sources & Archival References */}
        <div className="w-full max-w-[76rem] mx-auto px-4 sm:px-6 lg:px-8 min-w-0">
          <SourceList sources={ORIGIN_SOURCES} />
        </div>
      </div>
    </OriginPageShell>;
}